// Mobile-Drilldown: Pane-Switching.
//
// Markup: ein `.kd-mobile-drill` mit `data-active-pane="root"`. Drinnen Panes
// per data-pane-Attribut. Trigger ([data-open-pane="ID"]) öffnet die Sub-Pane,
// Back-Button ([data-close-pane]) kehrt zurück zur Root.
//
// Animation läuft via CSS (transform). JS macht nur:
//   - data-active-pane setzen
//   - .is-current toggeln
//   - aria-expanded synchronisieren
//   - Fokus-Management
//   - Reset bei Offcanvas-Close

(function () {
    'use strict';

    const ACTIVE_ATTR = 'data-active-pane';
    const ROOT = 'root';
    const TRANSITION_MS = 320;

    const init = () => {
        document.querySelectorAll('.kd-mobile-drill').forEach(initDrill);
    };

    const initDrill = (drill) => {
        drill.addEventListener('click', (event) => {
            const openBtn  = event.target.closest('[data-open-pane]');
            const closeBtn = event.target.closest('[data-close-pane]');

            if (openBtn) {
                event.preventDefault();
                openPane(drill, openBtn.getAttribute('data-open-pane'), openBtn);
                return;
            }

            if (closeBtn) {
                event.preventDefault();
                closePane(drill, closeBtn.getAttribute('data-opener'));
            }
        });

        drill.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;
            const active = drill.getAttribute(ACTIVE_ATTR);
            if (active && active !== ROOT) {
                event.stopPropagation();   // Offcanvas nicht mitschließen
                closePane(drill, active);
            }
        });

        // Reset bei Offcanvas-Schließen, damit ein erneutes Öffnen wieder
        // auf der Root-Pane startet.
        const offcanvas = drill.closest('.offcanvas');
        if (offcanvas) {
            offcanvas.addEventListener('hidden.bs.offcanvas', () => resetToRoot(drill));
        }
    };

    const openPane = (drill, paneId, opener) => {
        if (!paneId) return;

        drill.setAttribute(ACTIVE_ATTR, paneId);

        drill.querySelectorAll('.kd-mobile-pane').forEach((pane) => {
            pane.classList.toggle('is-current', pane.dataset.pane === paneId);
        });

        if (opener) {
            opener.setAttribute('aria-expanded', 'true');
        }

        const newPane = drill.querySelector(`.kd-mobile-pane[data-pane="${cssEscape(paneId)}"]`);
        if (!newPane) return;

        newPane.scrollTop = 0;
        const back = newPane.querySelector('[data-close-pane]');
        if (back) {
            window.setTimeout(() => back.focus(), TRANSITION_MS);
        }
    };

    const closePane = (drill, openerId) => {
        resetToRoot(drill);

        if (!openerId) return;
        const trigger = drill.querySelector(`[data-open-pane="${cssEscape(openerId)}"]`);
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            window.setTimeout(() => trigger.focus(), TRANSITION_MS);
        }
    };

    const resetToRoot = (drill) => {
        drill.setAttribute(ACTIVE_ATTR, ROOT);
        drill.querySelectorAll('.kd-mobile-pane').forEach((pane) => {
            pane.classList.toggle('is-current', pane.dataset.pane === ROOT);
        });
        drill.querySelectorAll('[data-open-pane][aria-expanded="true"]').forEach((trigger) => {
            trigger.setAttribute('aria-expanded', 'false');
        });
    };

    const cssEscape = (value) => {
        if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
            return CSS.escape(value);
        }
        return String(value).replace(/(["'\\])/g, '\\$1');
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
